import { Injectable } from "@angular/core";

@Injectable()
export class LoaderService {
  loading: boolean;
  constructor() { }

  startLoader(): boolean {
    return (this.loading = true);
  }

  stopLoader(): boolean {
    return (this.loading = false);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/loader.service.ts